<div class="templateTableMainDiv" *transloco="let translate">
    <div class="detailsHeaderContainer row">
        <div class="detailsHeaderText">
            <strong [textContent]="translate('Template List')"></strong>
        </div>
        <div class="iconsDiv">
            <material-button buttonType="icon" size="small" color="default" [disabled]="selectedTemplates.length === 0" [classList]="['!bottom-[8px]']" (buttonClicked)="deleteSelectedTemplates()" [titleText]="translate('Delete Selected Templates')" prefixIcon="delete_sweep" prefixIconType="material"></material-button>
            <mat-icon [title]="translate('Back To Run Reconciliation')" (click)="navigateToNewProcess()">close</mat-icon>
        </div>
    </div>
    <div class="notifyContentContainer">
        <perfect-scrollbar class="h-[calc(100vh-140px)]">
            <material-table [allTableColumns]="allTableColumns" [selectedColumns]="selectedColumns" [data]="tableData" [recordActions]="recordActions" [noRecordMsg]="translate('No Templates Found')" [noLog]="true" [defaultPaginator]="true" (recordSelectedEvent)="selectectedTemplate($event)"></material-table>
        </perfect-scrollbar>
    </div>
</div>
